import React, { useState } from "react"
import cx from "classnames"

import { Chevron } from "../../identity"
import { Detail } from "../../elements"

function Accordion(props: any) {
  const [state] = useState({
    collection: props.children,
  })
  let ref = React.useRef() as any

  return (
    <ul ref={ref}>
      {[...state.collection].map(item => (
        <AccordionItem key={item.key} item={item} state={state} />
      ))}
    </ul>
  )
}

function AccordionItem(props: any) {
  const content = React.useRef(null)
  const [height, setHeightState] = React.useState(0)
  const [open, setOpenState] = React.useState(false)
  const { item } = props

  function onClick(e: React.MouseEvent<HTMLElement>) {
    e.preventDefault()
    setOpenState(!open)
    setHeightState(
      !open ? (content.current ? (content.current as any).scrollHeight : 0) : 0
    )
  }

  return (
    <li className="box-border border-b border-gray-light">
      <button
        onClick={onClick}
        className="flex items-center w-full py-7 text-left focus:outline-none"
      >
        <Detail className="text-xl font-bold pr-3">{item.props.title}</Detail>
        <Chevron
          className={cx("shrink-0 ml-auto duration-300 ease-in-out transform", {
            "rotate-90": open,
          })}
          width={10}
          fill={"#979489"}
        />
      </button>
      <div
        ref={content}
        style={{ maxHeight: `${height}px` }}
        className="overflow-hidden duration-300 ease-in-out"
      >
        <div>{item.props.children}</div>
      </div>
    </li>
  )
}

export default Accordion
